import { useCallback, useMemo } from 'react';

const useFlightStopCount = ({ dispatch, value, initValue }) => {
  const onChange = useCallback(
    (selectedStops) => {
      dispatch({ type: 'NUMBER_STOPS_CHANGE', payload: selectedStops.value });
    },
    [dispatch]
  );

  return useMemo(
    () => ({ value, defaultValue: initValue, onChange, isChanged: initValue !== value }),
    [value, onChange, initValue]
  );
};

export default useFlightStopCount;
